<mat-spinner [color]="'accent'"></mat-spinner>